<template>
    <div>
        <el-button type="primary"
                   @click="startStuleTour"
                   :disabled="!tourAvailable">
            {{$t('textStylesTour.tourName')}}
        </el-button>

        <el-tour v-model="tourStart"
                 :target-area-clickable="false">

            <el-tour-step :target="sourceContainerTarget"
                          :title="$t('textStylesTour.sourceStyle')">
                <div>{{$t('textStylesTour.sourceStyleDescription')}}</div>
                <br />
                <div>{{$t('textStylesTour.supportedFiles')}}</div>
            </el-tour-step>

            <el-tour-step :target="taregetContainerTarget"
                          :title="$t('textStylesTour.targetStyle')"
                          :content-style="taregetContainerStyle">

                <div>{{$t('textStylesTour.targetStyleDescription')}}</div>

                <img class="screenshot"
                     src="@/images/Tours/text-style-tour.png"
                     alt="tour.png" />

                <div v-for="(decs, index) in subDescriptionsTwo"
                     :key="index">
                    {{decs}}
                </div>

            </el-tour-step>

            <el-tour-step :target="segmentContainerTarget"
                          :content-style="taregetContainerStyle">

                <div>{{$t('textStylesTour.paragraphFormatting')}}</div>
                <br />

                <div>{{$t('textStylesTour.badgeInfo')}}</div>

                <img class="screenshot"
                     src="@/images/Tours/style-badge-location.png"
                     alt="tour.png" />

                <div>{{$t('textStylesTour.wordStyleName')}}</div>

                <img class="screenshot"
                     src="@/images/Tours/style-word-location.png"
                     alt="tour.png" />

            </el-tour-step>


        </el-tour>
    </div>
</template>

<script lang="ts">
    import { defineComponent } from 'vue';
    import { shortcuts } from '@/utils/shortcuts';

    export default defineComponent({
        props: {
            tourAvailable: {
                type: Boolean,
                default: false,
            }
        },
        data() {
            return {
                tourStart: false,

                sourceContainerTarget: "#source-container",
                taregetContainerTarget: "#tareget-container",
                taregetContainerStyle: { width: '1000px' },

                subDescriptionsTwo: [
                    this.$t('textStylesTour.applyStyles'),
                    this.$t('textStylesTour.addLink'),
                    this.$t('textStylesTour.clearStyles'),
                    this.$t('textStylesTour.info', [shortcuts.clearStyles.win]),
                ],

                segmentContainerTarget: "#segment-container",

            };
        },

        methods: {
            startStuleTour() {
                const result = document.getElementById("shortcut-button");
                if (result != null) {
                    result.click();
                }
                this.tourStart = true;
            },
        },


    })
</script>

<style scoped>
    .screenshot {
        max-width: 100%;
        margin-top: 10px;
        margin-bottom: 10px;
    }
</style>